import Button, { type ButtonProps } from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

export interface UseConfirmProps {
  button?: string;
  buttonColor?: ButtonProps['color'];
  message: string;
  title: string;
}

const useConfirm = (props: UseConfirmProps) => {
  const { button = 'Confirm', buttonColor = 'error', message, title } = props;
  const [promise, setPromise] = useState<null | {
    resolve: (confirmed: boolean) => void;
  }>(null);

  const confirm = () => {
    return new Promise((resolve) => {
      setPromise({ resolve });
    });
  };

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const ConfirmationModal = () => (
    <Dialog open={promise !== null} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ pt: 2, pb: 1, whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color={buttonColor} onClick={handleConfirm} variant="contained">
          {button}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { ConfirmationModal, confirm };
};

export default useConfirm;
